import React from 'react';
import { Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
import SocialMediaButtons from '../SocialMediaButtons';

const Footer = ({ config = {} }) => {
  const logoUrl = config.logoUrl || 'https://customer-assets.emergentagent.com/job_talentmgmt/artifacts/dyyu0c3k_Disen%CC%83o%20sin%20ti%CC%81tulo.png';
  const brandName = config.brandName || 'JG Models Agency';
  const brandTagline = config.brandTagline || 'Transformamos modelos en marcas rentables';
  const contactEmail = config.contactEmail || 'gestion2jgmodels.com';

  return (
    <footer className="bg-black py-12 border-t border-gray-900">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-center md:text-left">
            <Link to="/" className="inline-flex items-center gap-3 transition-opacity hover:opacity-80">
              {logoUrl ? (
                <img 
                  src={logoUrl}
                  alt={brandName} 
                  className="h-12 w-auto"
                />
              ) : (
                <span className="text-2xl font-bold text-[#c8784e]">{brandName}</span>
              )}
            </Link>
            <p className="text-gray-400 mt-2 font-light italic">{brandTagline}</p>
          </div>

          <div className="flex flex-col items-center gap-3">
            <div className="flex items-center gap-3">
              <Mail size={20} className="text-[#c8784e]" />
              <a
                href={`mailto:${contactEmail}`}
                className="text-gray-400 font-light hover:text-[#c8784e] transition-colors"
              >
                {contactEmail}
              </a>
            </div>
          </div>
        </div>

        {/* Social Media Section */}
        <div className="mt-8 pt-8 border-t border-gray-900">
          <p className="text-center text-sm text-gray-400 mb-4">Síguenos en nuestras redes</p>
          <SocialMediaButtons variant="fixed" adminWhatsApp={true} brandColors={true} />
        </div>

        <div className="mt-8 pt-8 border-t border-gray-900 text-center relative">
          <p className="text-gray-500 text-sm font-light">
            © 2024 {brandName}. Todos los derechos reservados.
          </p>
          
          {/* Hidden CEO Button */}
          <Link
            to="/ceo-login"
            className="absolute bottom-0 right-4 text-gray-600 hover:text-gray-400 text-sm opacity-60 hover:opacity-100 transition-all cursor-pointer"
            title="Acceso CEO"
          >
            🔒 CEO
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;